export default __webpack_public_path__ + "static/media/javascript-logo.1d9f4141.png";